import jsPDF from "jspdf";
import dayjs from "dayjs";

import lawyerBo from "../../../../assets/images/license/3.png";

import "../../../../assets/font/THSarabunNew-normal";
import "../../../../assets/font/THSarabunNew-bold";

export async function ReprintLetterCarRepurchase(
  dataReprintLetterCarRepurchase = [],
) {
  //    const PDF_LetterRepurchase = (data = []) => { // เอกสารซื้อรถคืน
  const doc = new jsPDF("p", "mm", "a4");

  dataReprintLetterCarRepurchase.forEach((item, index) => {
    // 1. สร้าง jsPDF object และตั้งค่า

    let typeCus =
      item?.cusType === 0 ? "(ผู้เช่าซื้อ)" : `(ผู้ค้ำประกัน ${item.cusType})`;

    if (index > 0) {
      doc.addPage(); // เพิ่มหน้าใหม่
    }
    // const rightMargin = 190; // ขอบขวา 20mm
    // const leftMargin = 30;   // ขอบซ้าย 20mm
    // const contentWidth = rightMargin - leftMargin; // 170mm
    // const pageCenter = 105;
    let y = 20; // ตำแหน่ง Y เริ่มต้น
    const lineHeight = 8; // ระยะห่างบรรทัด (สำคัญเพื่อให้ดูเหมือนเอกสารจริง)

    // doc.addFont('THSarabunNew-normal.ttf', 'THSarabunNew', 'normal');
    // doc.addFont('TH Sarabun New Bold-normal.ttf', 'TH Sarabun New Bold', 'normal');
    doc.setFont("THSarabunNew", "normal");
    doc.setFontSize(14);

    // --- ส่วนหัว (ชื่อบริษัทและที่อยู่) ---
    doc.setFont("THSarabunNew", "normal");

    const address = `
                    กรุณาส่ง     ${item.CNAME} ${typeCus} (เลขที่สัญญา ${item?.CONTNO})
                                    เลขที่ ${item?.ADDR} 
                                    ต.${item?.TUMB} อ.${item?.AUMPDES} จ.${item?.PROVDES}
                                    ${item?.ZIP}
        `;
    doc.text(address, 5, y);
    y += 67;

    // --- วันที่ ---
    // const dataNow = dayjs(WaitHold?.CarImpound?.dateOfSeizure).format('D MMMM BBBB'); // เปลี่ยนเป็นวันที่ยึด

    // doc.text(`วันที่ ${dataNow}`, 160, y, { align: 'right' });
    y += 10;

    const s1 = `
        เรื่อง ให้ใช้สิทธิซื้อรถยนต์คืนก่อนบุคคลอื่น / แจ้งการประมูล
        `;
    doc.text(s1, 5, y);
    y += 7;

    const s2 = `
        เรียน ${item?.CNAME} ${typeCus} (เลขที่สัญญา ${item?.CONTNO})
        `;
    doc.text(s2, 5, y);
    y += 22;

    // --- เนื้อหา Paragraph 1 ---
    doc.setFont("THSarabunNew", "normal");

    doc.text(
      "ตามที่ได้ทำสัญญาเช่าซื้อและทำสัญญาค้ำประกันการเช่าซื้อรถยนต์ยี่ห้อ",
      25,
      y,
    );
    doc.setFont("THSarabunNew", "bold");
    doc.text(`${item?.TYPE}`, 125, y);

    doc.setFont("THSarabunNew", "normal");
    doc.text(" หมายเลขเครื่อง ", 145, y);

    // หมายเลขเครื่อง
    doc.setFont("THSarabunNew", "bold");
    doc.text(`${item?.ENGNO}`, 170, y);

    y += lineHeight;

    doc.setFont("THSarabunNew", "normal");
    doc.text(`หมายเลขตัวถัง `, 15, y);

    doc.setFont("THSarabunNew", "bold");
    doc.text(`${item?.STRNO}`, 40, y);

    doc.setFont("THSarabunNew", "normal");
    doc.text(`ทะเบียน `, 80, y);
    doc.setFont("THSarabunNew", "bold");
    doc.text(`${item?.REGNO}`, 95, y);

    doc.setFont("THSarabunNew", "normal");
    doc.text(`ไปจาก `, 115, y);

    doc.setFont("THSarabunNew", "bold");
    doc.text(`บริษัท ซีเอแอล 2009 จำกัด (เปลี่ยนชื่อเป็น `, 125, y);

    y += lineHeight;

    doc.setFont("THSarabunNew", "bold");
    doc.text(`บริษัท วันลิสซิ่ง จำกัด (สำนักงานใหญ่))`, 15, y);

    doc.setFont("THSarabunNew", "normal");
    doc.text(`ผู้ให้เช่าซื้อ เมื่อวันที่ `, 75, y);

    doc.setFont("THSarabunNew", "bold");
    doc.text(`${dayjs(item?.SDATE).format("D MMMM BBBB")}`, 105, y);

    doc.setFont("THSarabunNew", "normal");
    doc.text(`ในราคาเช่าซื้อ `, 135, y);

    doc.setFont("THSarabunNew", "bold");
    doc.text(
      `${Number(item?.TOTPRC).toLocaleString("th-TH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} บาท`,
      155,
      y,
    );

    y += lineHeight;

    doc.setFont("THSarabunNew", "normal");
    doc.text(`ตกลงผ่อนชำระงวดละ`, 15, y);

    doc.setFont("THSarabunNew", "bold");
    doc.text(
      `${Number(item?.TOT_UPAY).toLocaleString("th-TH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} `,
      50,
      y,
    );

    doc.setFont("THSarabunNew", "normal");
    doc.text(`บาทให้แล้วเสร็จภายใน `, 65, y);

    doc.setFont("THSarabunNew", "bold");
    doc.text(`${item?.T_NOPAY}`, 100, y);

    doc.setFont("THSarabunNew", "normal");
    doc.text(`งวด เริ่มงวดแรกวันที่ `, 110, y);

    doc.setFont("THSarabunNew", "bold");
    doc.text(`${dayjs(item?.FDATE).format("D MMMM BBBB")}`, 145, y);

    y += lineHeight;

    doc.setFont("THSarabunNew", "normal");
    doc.text(
      `โดยผู้คำ้ประกันยินยอมรับผิดหากผู้เช่าซื้อ ไม่ชำระหนี้ไม่ว่ากรณีใดๆ`,
      15,
      y,
    );

    y += lineHeight;

    doc.text(
      `บัดนี้ ปรากฏว่าท่านผิดสัญญา โดยได้ค้างชำระค่าเช่าซื้อต่อผู้ให้เช่าซื้อสามงวดติดต่อกัน และผู้ให้เช่าซื้อได้มีหนังสือบอกเลิกสัญญา`,
      25,
      y,
    );

    y += lineHeight;

    doc.text(
      `ต่อท่านแล้ว ต่อมาผู้ให้เช่าซื้อได้ติดตามรถยนต์คืนได้ ผู้ให้เช่าซื้อจึงประสงค์ให้ท่านใช้สิทธิซื้อรถยนต์ คันดังกล่าวคืนก่อนบุคคลอื่นตามสัญญา`,
      15,
      y,
    );
    y += lineHeight;

    doc.text(
      `โดยหนังสือฉบับนี้ ข้าพเจ้าในฐานะทนายความผู้รับมอบอำนาจผู้ให้เช่าซื้อ ขอแจ้งมายังท่านเพื่อให้ท่านใช้สิทธิซื้อรถยนต์`,
      25,
      y,
    );
    y += lineHeight;

    doc.text(
      `คันที่ให้เช่าซื้อคืนภายใน 20 วันนับแต่ได้รับหนังสือฉบับนี้ ในราคา `,
      15,
      y,
    );
    doc.setFont("THSarabunNew", "bold");
    doc.text(
      `${Number(item?.TOTPRC - item?.SMPAY).toLocaleString("th-TH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })} บาท`,
      110,
      y,
    );

    y += lineHeight;

    doc.setFont("THSarabunNew", "normal");
    doc.text(
      `หรือให้ท่านเข้าร่วมประมูลรถคันดังกล่าว (โดยวิธียื่นซองประมูล) ในวันที่ `,
      15,
      y,
    );
    doc.setFont("THSarabunNew", "bold");

    // doc.text(dayjs(WaitHold?.CarImpound?.dateOfSeizure).add(45, 'day').format('D MMMM BBBB'), 110, y);
    doc.setFont("THSarabunNew", "normal");
    doc.text(`เวลา 9.30 นาฬิกา ณ ที่ทำการผู้ให้เช่าซื้อ`, 140, y);

    y += lineHeight;

    doc.text(
      `เลขที่ 89 หมู่ 14 ต.ในเมือง อ.เมืองขอนแก่น จ.ขอนแก่น 40000`,
      15,
      y,
    );

    y += lineHeight;

    doc.text(
      `หากท่านเพิกเฉย ผู้ให้เช่าซื้อถือว่าหนังสือฉบับนี้เป็นการแจ้งให้ท่านได้รับทราบแล้ว หากขายทอดตลาดผู้ให้เช่าซื้อ`,
      25,
      y,
    );
    y += lineHeight;
    doc.text(
      `ต้องขาดทุนจำนวนเท่าใด ท่านยังคงต้องรับผิดชอบในส่วนนั้นอยู่ ข้าพเจ้าจำเป็นต้อง ดำเนินคดีกับท่าน ตามกฎหมายต่อไป`,
      15,
      y,
    );
    y += lineHeight;

    doc.text(`จึงเรียนมาเพื่อทราบและให้ถือปฏิบัติโดยเคร่งครัด`, 15, y);
    y += 10;

    doc.text("ขอแสดงความนับถือ", 130, y);
    y += lineHeight;

    // y += 14;

    // --- ส่วนลงนาม (จัดชิดขวา) ---
    // doc.text('ขอแสดงความนับถือ', 130, y,);
    y += 20; // เว้นระยะสำหรับลายเซ็น

    const signatureImg = lawyerBo; // ใส่ Base64 ของรูปคุณ

    // const offset = 10;
    doc.addImage(signatureImg, "PNG", 125, 243, 40, 17);

    doc.text("ร้อยตำรวจโทพงษ์ศรา วงษ์วีระขันธ์", 120, y);
    y += 7;
    doc.text("ทนายความผู้รับมอบอำนาจ", 125, y);
    y += 7;
    doc.text("ติดต่อ 043-239888 , 063-3131734", 118, y);
    y += 7;

    // doc.autoPrint();
    // window.open(doc.output('bloburl'));
  });

  // เพิ่มหน้าใหม่
  // doc.addPage();

  // ตั้งค่าฟอนต์
  doc.setFont("THSarabunNew", "normal");
  doc.setFontSize(16);

  // // config layout
  // let finalYLeft = 20;
  // let finalYRight = 20;
  // let leftX = 10;
  // let rightX = 115; // จุดเริ่มคอลัมน์ขวา
  // let rowHeight = 30; // ความสูงต่อคน
  // let count = 0;
  // let columnCount = 0;

  // dataReprintLetterCarRepurchase.forEach((person, index) => {
  //     const x = count % 2 === 0 ? leftX : rightX;
  //     let y = count % 2 === 0 ? finalYLeft : finalYRight;

  //     // --- ชื่อ + ประเภท ---
  //     const nameType = `${person.NAME} (${person.cusType === 0
  //         ? person.dataType === "lsfhp"
  //             ? "ผู้กู้"
  //             : "ผู้เช่าซื้อ"
  //         : "ผู้ค้ำประกัน " + person.cusType
  //         }) (${person.CONTNO})`;
  //     doc.text(nameType, x, y);
  //     y += 6;

  //     // --- ที่อยู่ บรรทัด 1 ---
  //     if (person.ADDRESS?.ADDR1) {
  //         doc.text(`เลขที่ ${person.ADDR1}`, x, y);
  //         y += 6;
  //     }

  //     // --- ที่อยู่ บรรทัด 2 ---
  //     const addrLine2 = `ต.${person.TUMB} อ.${person.AUMPDES} จ.${person.PROVDES}`;
  //     doc.text(addrLine2, x, y);
  //     y += 6;

  //     // --- ZIP ---
  //     doc.text(person.ADDRESS.ZIP || "", x, y);

  //     // --- อัปเดต Y ตามคอลัมน์ ---
  //     if (count % 2 === 0) {
  //         finalYLeft += rowHeight;
  //     } else {
  //         finalYRight += rowHeight;
  //         columnCount++;
  //     }

  //     count++;

  //     // --- ถ้าเกิน 9 แถวต่อคอลัมน์ (18 คน) ขึ้นหน้าใหม่ ---
  //     if (columnCount > 8) {
  //         columnCount = 0;
  //         console.log(" columnCount 0", columnCount);
  //         doc.addPage();
  //         doc.setFont("THSarabunNew", "normal");
  //         doc.setFontSize(16);
  //         finalYLeft = 20;
  //         finalYRight = 20;
  //     }
  // });
  // 3. แสดงผล PDF

  doc.autoPrint();
  const blobUrl = doc.output("bloburl");
  window.open(blobUrl);
}
// export default ReprintLetterCarRepurchase;
